import { buildGameUrl } from '@/common/utils/code-gen';
import { Interpolation, Theme } from '@emotion/react';
import {
  borderRadius,
  Card,
  CardBody,
  CardHeader,
  colors,
  FlexColumn,
  font,
  fontFamilies,
  fontSizes,
  paddingHorizontal,
  StrokeText,
} from '@toilet-paper-games/ui';
import { observer } from 'mobx-react-lite';
import { QRCode } from './QRCode';

const joinLinkStyle: Interpolation<Theme> = [
  { letterSpacing: -2, transition: 'filter 0.3s' },
  font(fontFamilies.primary, fontSizes.xl, 1, colors.warningBorder),
  paddingHorizontal('md'),
];

export interface ScanCardProps {
  joinId: string;
  className?: string;
}

export const ScanCard = observer((props: ScanCardProps) => {
  const { className, joinId } = props;

  return (
    <a
      className={className}
      css={{ all: 'unset', cursor: 'pointer', '&:visited': { all: 'unset' } }}
      href={buildGameUrl(joinId)}
      target="_blank"
      rel="noreferrer"
    >
      <FlexColumn alignItems="center">
        <Card
          shadow
          solid={false}
          inset
          css={[
            {
              width: 250,
              aspectRatio: '1',
              backgroundColor: '#284f67',
            },
            borderRadius('sm'),
          ]}
          noPadding
        >
          <CardHeader
            css={[{ textAlign: 'center' }, font(fontFamilies.secondary, fontSizes.sm)]}
          >
            {'visit '}
            <StrokeText
              strokeColor={colors.componentSolid}
              css={{ textDecoration: 'underline' }}
            >
              tp.games
            </StrokeText>
          </CardHeader>
          <CardBody>
            <QRCode code={joinId} />
          </CardBody>
        </Card>
        <StrokeText
          strokeWidth={10}
          color={colors.warning}
          css={[
            joinLinkStyle,
            font(fontFamilies.primary, '3.5em', 1, colors.warningBorder),
          ]}
        >
          {joinId}
        </StrokeText>
      </FlexColumn>
    </a>
  );
});
